import React from 'react';
import './App.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

function App() {
  return (
    <div className="app">
      <header className="site-header">
        <div className="page-container header-inner">
          <div className="brand">
            <p className="brand-name">Ahmed Riaz</p>
            <span className="brand-role">CEO, Devritech Pvt Limited</span>
          </div>
          <a
            href="https://www.linkedin.com/in/ahmed-riaz/"
            className="linkedin-link"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn"
          >
            <i className="fab fa-linkedin-in"></i>
          </a>
        </div>
      </header>

      <main className="site-main" id="main-content">
        <article
          className="profile-section"
          itemScope
          itemType="https://schema.org/Person"
          aria-labelledby="profile-heading"
        >
          <div className="page-container profile-grid">
            <div className="profile-copy">
              <h1 id="profile-heading" className="profile-heading" itemProp="name">
                Ahmed Riaz
              </h1>
              <p className="profile-role" itemProp="jobTitle">
                Chief Executive Officer,{' '}
                <span itemProp="worksFor" itemScope itemType="https://schema.org/Organization">
                  <span itemProp="name">Devritech Pvt Limited</span>
                </span>
              </p>
              <p className="profile-lead">
                <span className="visually-hidden">Ahmed Riaz — </span>
                Chief Executive Officer of Devritech Pvt Limited, a software company delivering
                enterprise platforms, AI solutions, and custom applications for clients worldwide.
              </p>
              <p className="profile-body">
                With more than a decade in the industry, Ahmed Riaz oversees strategy, delivery, and
                client relationships—ensuring every engagement is executed with clarity, discipline, and
                measurable business value.
              </p>
              <ul className="profile-tags">
                <li>Leadership</li>
                <li>Enterprise Software</li>
                <li>Global Partnerships</li>
                <li>Digital Transformation</li>
              </ul>
            </div>

            <figure className="profile-visual">
              <div className="profile-photo">
                <img
                  src={`${process.env.PUBLIC_URL}/images/ahmed-riaz.png`}
                  alt="Ahmed Riaz, Chief Executive Officer of Devritech Pvt Limited"
                  itemProp="image"
                  width="380"
                  height="475"
                  loading="eager"
                  fetchPriority="high"
                />
              </div>
              <figcaption className="profile-caption">
                <span>Chief Executive Officer</span>
                <span>Devritech Pvt Limited</span>
              </figcaption>
            </figure>
          </div>
        </article>
      </main>

      <footer className="site-footer">
        <div className="page-container">
          <p>&copy; 2026 Ahmed Riaz · Devritech Pvt Limited</p>
        </div>
      </footer>
    </div>
  );
}

export default App;
